interface SaveCountdownProps {
  timeLeft: number;
}

const SaveCountdown = ({ timeLeft }: SaveCountdownProps) => {
  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60000);
    const seconds = Math.floor((time % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  return (
    <div style={{ color: "#A7A7A7", marginLeft: "5px" }}>
      ({formatTime(timeLeft)})
    </div>
  );
};

export default SaveCountdown;
